import title from "./title.mdx";
import intro from "presentations/common/intro/intro.mdx";
import reduxDead from "./reduxDead/reduxDead.mdx";
import reactRedux from "./reactRedux/reactRedux.mdx";

import rtk from "./rtk/rtk.mdx";

import docs from "./docs/docs.mdx";
import furtherInformation from "./furtherInformation/furtherInformation.mdx";

const slideContents = [
  ...title,
  ...intro,
  ...reduxDead,
  ...reactRedux,
  ...rtk,
  ...docs,
  ...furtherInformation,
];

export default slideContents;
